import {
    FileDownloadIcon,
    FilterOutlineIcon,
    PlaylistAddCheckIcon
} from "@dotnet/telematics-design-system";

import { TRI_SOURCES } from "shared";

export const ALL_TABS = [
    {
        source: TRI_SOURCES.Selected,
        label: "selected",
        icon: PlaylistAddCheckIcon
    },
    {
        source: TRI_SOURCES.Filtered,
        label: "filtered",
        icon: FilterOutlineIcon
    },
    { source: TRI_SOURCES.FromFile, label: "from file", icon: FileDownloadIcon }
];
